"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const classnames_1 = __importDefault(require("classnames"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const transactionsConfig_1 = require("components/TransactionRegister/transactionsConfig");
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const ClrField = (_a) => {
    var { value, autoFocus, onChange, editable, includeEmpty } = _a, other = __rest(_a, ["value", "autoFocus", "onChange", "editable", "includeEmpty"]);
    const { classes } = useStyles();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const btnRef = (0, react_1.useRef)(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
    };
    const handleClose = (item) => {
        setAnchorEl(null);
        if (onChange && item) {
            onChange({ target: { value: item.state } });
        }
        setTimeout(() => { var _a; return (_a = btnRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 100);
    };
    const onKeyDown = (event) => {
        if (event.key === 'Escape' || event.key === 'Enter') {
            event.stopPropagation();
            setAnchorEl(null);
        }
    };
    const makeReconcileIcon = (val) => (<div className={(0, classnames_1.default)(classes.clrFieldIcon, val)}>
      <QTypography_1.default className={classes.iconFont} thinFont>
        {`${(val || ' ').toUpperCase().charAt(0)}`}
      </QTypography_1.default>
    </div>);
    const makeMenuItem = (item, hasIcon = true) => {
        if (item.menu) {
            const text = item.label;
            return (<MenuItem_1.default key={`clrmenu:${item.label}`} onClick={() => handleClose(item)}>
          {hasIcon && <ListItemIcon_1.default>{makeReconcileIcon(item.label)}</ListItemIcon_1.default>}

          {<ListItemText_1.default>{text}</ListItemText_1.default>}
        </MenuItem_1.default>);
        }
        return null;
    };
    const menuItems = transactionsConfig_1.clrFieldOptions.options.map((item) => makeMenuItem(item));
    if (includeEmpty) {
        menuItems.push(makeMenuItem({ label: ' No Change', value: ' ' }));
    }
    const currItemRef = transactionsConfig_1.clrFieldOptions.options.find((x) => x.state === value);
    const noChangeText = ' ';
    if (editable) {
        return (<div {...other}>
        <ButtonBase_1.default {...other} autoFocus={autoFocus} aria-owns={anchorEl ? 'clrField-menu' : undefined} aria-haspopup="true" focusRipple onClick={handleClick} ref={btnRef} action={(actions) => {
                if (autoFocus && actions) {
                    actions.focusVisible();
                }
            }}>
          {makeReconcileIcon(currItemRef ? currItemRef.label : noChangeText)}
        </ButtonBase_1.default>
        {editable && (<Menu_1.default id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleClose(null)} onKeyDown={onKeyDown}>
            {menuItems}
          </Menu_1.default>)}
      </div>);
    }
    return makeReconcileIcon(currItemRef ? currItemRef.label : ' ');
};
exports.default = ClrField;
